import http from './http';
import { listResource } from './listResource';

/**
 * Obtener lista de especialidades
 */
export async function listSpecialties(options = {}) {
    const result = await listResource('/specialties/all', options);

    // Adaptar respuesta si viene en formato { specialties: [] }
    if (result.items && result.items.specialties) {
        return {
            items: result.items.specialties,
            total: result.total || result.items.specialties.length
        };
    }

    return result;
}

/**
 * Obtener una especialidad por ID
 */
export async function getSpecialtyById(id) {
    const res = await http.get(`/specialties/${id}`);
    return res.data?.data ?? res.data;
}

/**
 * Crear una nueva especialidad
 */
export async function createSpecialty(data) {
    const isFormData = data instanceof FormData;
    const res = await http.post('/specialties', data, {
        headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return res.data?.data ?? res.data;
}

/**
 * Actualizar una especialidad
 */
export async function updateSpecialty(id, data) {
    const isFormData = data instanceof FormData;
    const res = await http.put(`/specialties/${id}`, data, {
        headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return res.data?.data ?? res.data;
}

/**
 * Eliminar una especialidad
 */
export async function deleteSpecialty(id) {
    const res = await http.delete(`/specialties/${id}`);
    return res.data?.data ?? res.data;
}
